// Import the TextSplitter class for handling text splitting.
// Import debounce utility function.
// Defines a debounce function to limit the rate at which a function can fire.
const $c72b185320e6bb41$export$61fc7d43ac8f84b0 = (func, delay)=>{
    let timerId; // Holds a reference to the timeout between calls.
    return (...args)=>{
        clearTimeout(timerId); // Clears the current timeout, if any, to reset the debounce timer.
        timerId = setTimeout(()=>{
            func.apply(undefined, args); // Calls the passed function after the specified delay with the correct context and arguments.
        }, delay);
    };
};


class $300907e9ca2976b9$export$d267c32dfbb2bb04 {
    // Constructor for TextScrollEffect which sets up the text animation.
    // Parameters:
    //   textElement: HTMLElement - The DOM element that contains the text to be animated.
    //   options: Object (optional) - Configuration options for the text splitting and callbacks.
    //     options.resizeCallback: Function - A function to call on window resize events.
    //     options.splitTypeTypes: String - Specifies the types of splits to perform on the text. 
    //         Possible values are based on SplitType's configuration, such as 'lines', 'words', 'chars'.
    //         See SplitType documentation for more details: https://github.com/lukePeavey/SplitType
    // This constructor initializes the text splitting with specified options, sets up resize handling,
    // and prepares the text element for animation effects.
    constructor(textElement, options = {}){
        // Ensure the textElement is a valid HTMLElement.
        if (!textElement || !(textElement instanceof HTMLElement)) throw new Error('Invalid text element provided.');
        const { resizeCallback: resizeCallback, splitTypeTypes: splitTypeTypes } = options;
        this.textElement = textElement;
        // Assign the resize callback if provided and is a function, otherwise null.
        this.onResize = typeof resizeCallback === 'function' ? resizeCallback : null;
        // Set options for SplitType based on provided splitTypeTypes or default to SplitType's default behavior.
        // The 'types' option allows customization of how text is split (e.g., into lines, words, characters).
        // Refer to SplitType documentation for possible values and updates: https://github.com/lukePeavey/SplitType
        const splitOptions = splitTypeTypes ? {
            types: splitTypeTypes
        } : {};
        this.splitText = new SplitType(this.textElement, splitOptions);
        // Initialize ResizeObserver to re-split text on resize events, if a resize callback is provided.
        if (this.onResize) this.initResizeObserver(); // Set up observer to detect resize events.
    }
    // Sets up ResizeObserver to re-split text on element resize.
    initResizeObserver() {
        this.previousContainerWidth = null; // Track element width to detect resize.
        let resizeObserver = new ResizeObserver((0, $c72b185320e6bb41$export$61fc7d43ac8f84b0)((entries)=>this.handleResize(entries), 100));
        resizeObserver.observe(this.textElement); // Start observing the text element.
    }
    // Handles element resize, re-splitting text if width changes.
    handleResize(entries) {
        const [{ contentRect: contentRect }] = entries;
        const width = Math.floor(contentRect.width);
        // If element width changed, re-split text and call resize callback.
        if (this.previousContainerWidth && this.previousContainerWidth !== width) {
            this.splitText.split(); // Re-split text for new width.
            this.onResize(); // Execute the callback function.
        }
        this.previousContainerWidth = width; // Update stored width.
    }
    // Returns the lines created by splitting the text element.
    getLines() {
        return this.splitText.lines;
    }
    // Returns the words created by splitting the text element.
    getWords() {
        return this.splitText.words;
    }
    // Returns the chars created by splitting the text element.
    getChars() {
        return this.splitText.chars;
    }
}


class $c32a6be49a878e2f$export$824eb2eeafc81b63 {
    constructor(textElement){
        // Check if the provided element is valid.
        if (!textElement || !(textElement instanceof HTMLElement)) throw new Error('Invalid text element provided.');
        this.textElement = textElement;
        // Set up the effect for the provided text element.
        this.initializeEffect();
    }
    // Sets up the initial text effect on the provided element.
    initializeEffect() {
        // Callback to re-trigger animations on resize.
        const textResizeCallback = ()=>this.scroll();
        // Split text for animation and store the reference.
        this.splitter = new (0, $300907e9ca2976b9$export$d267c32dfbb2bb04)(this.textElement, {
            resizeCallback: textResizeCallback,
            splitTypeTypes: 'words, chars'
        });
        // Trigger the initial scroll effect.
        this.scroll();
    }
    // Animates text based on the scroll position.
    scroll() {
        // add matchMedia for responsive queries
        let mm = gsap.matchMedia();
        mm.add({
            isMobile: "(max-width: 767px)",
            isDesktop: "(min-width: 768px)"
        }, (context)=>{
            let { isMobile: isMobile, isDesktop: isDesktop } = context.conditions;
            // Query all individual characters in the line for animation.
            const chars = this.splitter.getChars();
            gsap.fromTo(chars, {
                filter: isMobile ? 'blur(0px) opacity(0%)' : 'blur(10px) opacity(0%)',
                willChange: 'filter'
            }, {
                ease: 'none',
                filter: 'blur(0px) opacity(100%)',
                stagger: 0.1,
                scrollTrigger: {
                    trigger: this.textElement,
                    start: 'top bottom-=25%',
                    end: 'bottom center+=25%',
                    scrub: true
                }
            });
        });
    }
}


/**
 * Preload fonts
 * @param {String} id
 */ const $a6df9c40ba402dc9$export$f2704129bd95623f = (id)=>{
    return new Promise((resolve)=>{
        WebFont.load({
            typekit: {
                id: id
            },
            active: resolve
        });
    });
};


// Registers the ScrollTrigger plugin with GSAP
gsap.registerPlugin(ScrollTrigger);
const $8f6a480bb40b134f$var$init = ()=>{
    const effects = [
        {
            selector: '[data-effect-1]',
            effect: (0, $c32a6be49a878e2f$export$824eb2eeafc81b63)
        }
    ];
    // Iterate over each effect configuration and apply the effect to all matching elements
    effects.forEach(({ selector: selector, effect: effect })=>{
        document.querySelectorAll(selector).forEach((el)=>{
            new effect(el);
        });
    });
};
// Preload images and fonts and remove loader
(0, $a6df9c40ba402dc9$export$f2704129bd95623f)('lnu1fpi').then(()=>{
    document.body.classList.remove('loading');
    $8f6a480bb40b134f$var$init();
});


//# sourceMappingURL=Never-Without.875c6496.js.map
